import React from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { TravelCollections } from '../components/TravelCollections';
import { BrandStory } from '../components/BrandStory';
import { WhyIndotravelista } from '../components/WhyIndotravelista';
import { Testimonials } from '../components/Testimonials';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';

export const HomePage = () => {
  return (
    <div>
      <Navigation />
      <WhatsAppButton variant="floating" />
      <HeroSection />
      <AboutSection />
      <TravelCollections />
      <BrandStory />
      <WhyIndotravelista />
      <Testimonials />
      <FinalCTA />
      <Footer />
    </div>
  );
};
